// @flow
import React, { Component } from "react";
// import IDRMillionDollar2021EntryForm from "./components/custom-forms/idr-2021-milliondollarjan";
import Form from "./components/custom-forms/idr-2026-jamaica";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import "isomorphic-fetch";
import promise from "es6-promise";
promise.polyfill();

if (!Object.entries)
  /* $FlowFixMe */
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };

if (typeof Object.assign != "function") {
  /* $FlowFixMe */
  Object.defineProperty(Object, "assign", {
    /* $FlowFixMe */
    value: function assign(target, varArgs) {
      // .length of function is 2
      // 'use strict';
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError("Cannot convert undefined or null to object");
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true,
  });
}

class App extends Component<*> {
  render(): Object {
    return (
      <Router>
        <Switch>
          {/* <Route path="/indemandradio/namethattool" exact render={(props) => <CheckatradeEntryForm />} /> */}
          {/* <Route path="/indemandradio/fancyaride" exact render={(props) => <Form />} />*/}
          <Route
            path="/indemandradio/jamaica2026"
            exact
            render={(props) => <Form />}
          />
          {/* <Route path="/indemandradio/guestmix2020" exact render={(props) => <IDRGuestMix2020EntryForm />} /> */}
          {/* <Route path="/signature" exact render={(props) => <BookingForm {...props} showAgent={true} agent="signature" />} /> */}
          <Route path="/" render={() => <div>Not found!</div>} />
        </Switch>
      </Router>
    );
  }
}

if (process.env.NODE_ENV === "production") {
  window.onbeforeunload = function () {
    return "Did you save your stuff?";
  };
}
export default App;
